import { SceneWithUserNames } from '../../../../types/scene.types';

// 计算场次排序序号
export const calculateSceneOrder = (scenes: SceneWithUserNames[], sceneId: string): number => {
  const index = scenes.findIndex(scene => scene.sceneID === sceneId);
  return index !== -1 ? index + 1 : 0;
};

// 将页数值安全转换为数字（支持字符串和数字类型）
export const parsePagesNumber = (value: number | string | null | undefined): number => {
  if (value === null || value === undefined) return 0;
  if (typeof value === 'number') {
    return isNaN(value) ? 0 : value;
  }
  if (typeof value === 'string') {
    const num = parseFloat(value);
    return isNaN(num) ? 0 : num;
  }
  return 0;
};

// 计算总页数（所有场次的页数累计）
export const calculateTotalPages = (scenes: SceneWithUserNames[]): number => {
  const total = scenes.reduce((sum, scene) => {
    const pages = parsePagesNumber(scene.scenePagesNumber);
    return sum + pages;
  }, 0);
  return total;
};

// 计算当前场次之前的页数累计
export const calculatePagesUpToScene = (scenes: SceneWithUserNames[], sceneId: string): number => {
  const currentIndex = scenes.findIndex(scene => scene.sceneID === sceneId);
  if (currentIndex === -1) return 0;
  
  let totalPages = 0;
  for (let i = 0; i <= currentIndex; i++) {
    const pages = parsePagesNumber(scenes[i].scenePagesNumber);
    totalPages += pages;
  }
  return totalPages;
};


